import React, { useEffect, useState } from 'react';
import { apiGet } from '../../lib/api';
import { Building2, Users, Inbox, Store } from 'lucide-react';

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { apiGet('/admin/dashboard').then(r => setS(r.data)).catch(() => {}); }, []);
  const Card = ({ Icon, label, value }) => (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-soft p-6">
      <div className="w-10 h-10 rounded-xl bg-rozops-blue-light text-rozops-blue grid place-items-center mb-3"><Icon className="w-5 h-5" /></div>
      <div className="text-xs uppercase tracking-widest font-bold text-rozops-text-muted">{label}</div>
      <div className="font-heading font-extrabold text-3xl text-rozops-navy mt-1">{value ?? '—'}</div>
    </div>
  );
  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <h1 className="font-heading font-extrabold text-3xl text-rozops-navy">Platform overview</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card Icon={Building2} label="Total merchants" value={s?.total_merchants} />
        <Card Icon={Store} label="Active merchants" value={s?.active_merchants} />
        <Card Icon={Users} label="Platform customers" value={s?.total_customers} />
        <Card Icon={Inbox} label="New leads" value={s?.new_leads} />
      </div>
    </div>
  );
}
